/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
// import useData from '../../components/hooks/useData'
import Topbar from '../../components/common/topbar/Topbar'
import { FilterTable, FilterTableType, TableDetailCell, TableHeaderCell, TransactionAudit } from '../../model/models-module'
import { addParam, formatParamDate } from '../../utils/CommonUtils'
import {useData} from '../../components/hooks/useData'
import DataTable from '../../components/common/datatable/Datatable'
import { CircularProgress, Tooltip, Typography} from '@mui/material'
import TextWithPopover from '../../components/common/text-with-popOver/TextWithPopover'
import ButtonToCopy from '../../components/common/ButtonToCopy'
import classes from './TransactionsReport.module.css'
import { GridDTO } from '../../model/dto-module'


// const gridActions = 
const TransactionsReport = () => {
  const [dataHeader, setDataHeader] = useState<TableHeaderCell[]>([]);
  const [dataTo, setDataTo] = useState<number>(50);
  const [countItems, setCountItems] = useState<number>(0);
  const [dataOffset, setDataOffset] = useState<number>(0);
  const [relatedEntityCode1, setRelatedEntityCode1] = useState<string>();
  const [sourceSystem, setsourceSystem] = useState<string>();
  const [destinationSystem, setDestinationSystem] = useState<string>();
  const [status, setStatus] = useState<string>();
  const [transactionDate, setTransactionDate] = useState<string>();
  const [transactionType, setTransactionType] = useState<string>();
  const [issueDateFrom, setIssueDateFrom] = useState<Date|undefined>()
  const [issueDateTo, setIssueDateTo] = useState<Date|undefined>()

  const [dataShow, setDataShow] = useState<TableDetailCell[]>([]);
  const [page, setPage] = useState<number>(1);

  const [baseEndpoint, setBaseEndpoint] = useState<string>('transaction-audit');  
  const [endpoint, setEndPoint] = useState<string>('transaction-audit');  
  const [params] = useState<Map<string,string>>(new Map());  
  const [statusEnumloading, statusEnumerror, statusEnum] = useData<string[]>('transaction-audit/status', 'GET', undefined)
  const [loading, error, dataGrid] = useData<GridDTO<TransactionAudit>>(endpoint, 'GET', undefined);

  const formatearFecha = (date: string) => {
    const fechaObj = new Date(date.replace('Z', ''));
    
    const año = fechaObj.getFullYear();
    const mes = (fechaObj.getMonth() + 1).toString().padStart(2, '0');
    const dia = fechaObj.getDate().toString().padStart(2, '0');
    const hora = fechaObj.getHours().toString().padStart(2, '0');
    const minutos = fechaObj.getMinutes().toString().padStart(2, '0');
    
    return `${dia}/${mes}/${año} ${hora}:${minutos}`;
  }

  if(error) {
    console.error(error);
  }

  useEffect(()=> {
    if (baseEndpoint == '') setBaseEndpoint('/')
  }, [baseEndpoint])

  useEffect(()=> {
    setDataOffset(0)
    addParam(relatedEntityCode1, 'relatedEntityCode1', params, baseEndpoint, setEndPoint);
  }, [relatedEntityCode1, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(sourceSystem, 'sourceSystem', params, baseEndpoint, setEndPoint);
  
  }, [sourceSystem, baseEndpoint]);

  useEffect(()=> {
      setDataOffset(0)
      addParam(destinationSystem, 'destinationSystem', params, baseEndpoint, setEndPoint);
    
  }, [destinationSystem, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(status, 'status', params, baseEndpoint, setEndPoint);
  
  }, [status, baseEndpoint]);

  useEffect(()=> {
    addParam(dataTo, 'size', params, baseEndpoint, setEndPoint);
  }, [dataTo, baseEndpoint]);

  useEffect(()=> {
    setDataShow([])
    addParam(dataOffset, 'page', params, baseEndpoint, setEndPoint);
  }, [dataOffset, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(transactionType, 'transactionType', params, baseEndpoint, setEndPoint);

  }, [transactionType, baseEndpoint]);

  useEffect(()=> {
    setDataOffset(0)
    addParam(transactionDate?.replaceAll('/', '-'), 'transactionDate', params, baseEndpoint, setEndPoint);

  }, [transactionDate, baseEndpoint]);

  useEffect(() => {
    setDataOffset(0)
    const fechaFormateada = formatParamDate(issueDateFrom)
    addParam(fechaFormateada, 'issueDateFrom', params, baseEndpoint, setEndPoint)
  }, [issueDateFrom, baseEndpoint])

  useEffect(() => {
    setDataOffset(0)
    const fechaFormateada = formatParamDate(issueDateTo)
    addParam(fechaFormateada, 'issueDateTo', params, baseEndpoint, setEndPoint)
  }, [issueDateTo, baseEndpoint])

  useEffect(()=> {
    let filterLoadeed = !loading && dataGrid != null && dataHeader.length === 0;
    // filterLoadeed = filterLoadeed && !loadingTypes && dataTypes != null 

    if(filterLoadeed ) {
      setDataHeader([
        new TableHeaderCell({
          label: 'Fecha', 
          key: 'transactionDate', 
          sorteable: false, 
          filter: new FilterTable({
            onChange: (newVal: any) => {
              setIssueDateFrom(newVal.from)
              setIssueDateTo(newVal.to)
            },
            value: {
              issueDateFrom,
              issueDateTo
            },
            type: FilterTableType.DATE
          }),
          colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '120px'}}),
        new TableHeaderCell({label: 'Tipo', key: 'transactionType', sorteable: false, filter: new FilterTable({onChange: (newVal: any)=>{ setTransactionType(newVal)}, placeholder: 'Busca aqui...'  }),colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({label: 'SKU', key: 'relatedEntityCode1', sorteable: false,filter: new FilterTable({onChange: (newVal: any)=>{ setRelatedEntityCode1(newVal)}, placeholder: 'Busca aqui...'  }),  colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({label: 'Origen', key: 'sourceSystem', sorteable: false, colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({label: 'Entrada', key: 'inputData', sorteable: false, colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({label: 'Destino', key: 'destinationSystem', sorteable: false, filter: new FilterTable({onChange: (newVal: any)=>{ setDestinationSystem(newVal)}, placeholder: 'Busca aqui...'  }), colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({label: 'Salida', key: 'outputData', sorteable: false, colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({
          label: 'Estado', 
          key: 'status', 
          sorteable: false,
          filter: new FilterTable({
            onChange:  (newVal: any)=>{ setStatus(newVal)}, 
            useCodeField:true, 
            data: statusEnum! ? statusEnum.map((statusName, i)=>{return {id: i+1, code: statusName, description: statusName};}) : [], 
            type: FilterTableType.MULTIPLE}),  
          colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
        new TableHeaderCell({label: 'Detalle', key: 'statusDetail', sorteable: false, colStyle: {whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}),
      ])  
    }
  })

  

  useEffect(()=>{
    if(!loading && dataGrid) {
      setCountItems(dataGrid.count)
      dataGrid.results.sort((a, b) => {
        const fechaA = new Date(a.created).getTime();
        const fechaB = new Date(b.created).getTime();
        return fechaB - fechaA;
      });
      setDataShow(dataGrid.results.map((r) => {
        return new TableDetailCell({...r, transactionDate: formatearFecha(r.transactionDate)}, [],
          new Map<string, React.ReactNode>([
            ['relatedEntityCode1',
              <div key={r.relatedEntityCode1 + 'relatedEntityCode1'} className={classes['textWithCopy']}>
                {r.relatedEntityCode1 && r.relatedEntityCode1.length < 11 ? <Typography fontSize={'0.875rem'} whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflow={'hidden'}>{r.relatedEntityCode1 ?? ''}</Typography> : <Tooltip title={r.relatedEntityCode1}><Typography  whiteSpace={'nowrap'} textOverflow={'ellipsis'} overflow={'hidden'} fontSize={'0.875rem'} maxWidth={93}>{r.relatedEntityCode1 ?? ''}</Typography></Tooltip>}
                <ButtonToCopy text={r.relatedEntityCode1 ?? ''} style={{position: 'relative', right: '0px', top: '-10px'}}></ButtonToCopy>
              </div>
            ],
            ['inputData',
              <div key={r.inputData + 'inputData'} className={classes['textWithCopy']} style={{bottom: '10px'}}>
              <TextWithPopover key={'inputData'} text={'Ver detalle'} popoverText={r.inputData && r.inputData != '' ? r.inputData : "Esta transacción no tiene datos"}></TextWithPopover>
              <ButtonToCopy text={r.inputData} style={{position: 'relative', right: '-5px', top: '-8px'}}></ButtonToCopy>
              </div>
            ],
            ['outputData',
              <div key={r.outputData + 'outputData'} className={classes['textWithCopy']} style={{bottom: '10px'}}>
              <TextWithPopover key={'outputData'} text={'Ver detalle'} popoverText={r.outputData && r.outputData != '' ? r.outputData : "Esta transacción no tiene datos"}></TextWithPopover>
              <ButtonToCopy text={r.outputData} style={{position: 'relative', right: '-5px', top: '-8px'}}></ButtonToCopy>
              </div>
            ],
            ['statusDetail',
              <div key={r.statusDetail + 'statusDetail'} className={classes['textWithCopy']} style={{bottom: '10px'}}>
              <TextWithPopover key={'statusDetail'} text={'Ver detalle'} popoverText={r.statusDetail && r.statusDetail != '' ? r.statusDetail : "Esta transacción no tiene datos"}></TextWithPopover>
              <ButtonToCopy text={r.statusDetail} style={{position: 'relative', right: '-5px', top: '-8px'}}></ButtonToCopy>
              </div>
            ],
        ]),
        classes['customRow']
          )
      }))
    }
  }, [setDataShow, dataGrid, loading]);

  function reloadTable() {
    setBaseEndpoint('/')
    setEndPoint('transaction-audit')
  }

  return (
    <div className={classes.errorTransactionPage}>
    {
      loading ?
      <div className='loadingPage'>
        <CircularProgress className='circleProgress'/>
      </div>
      : null
    }
      <Topbar title={'Monitor de transacciones'} hasReloadIcon reloadPage={reloadTable} />
    <div className={classes['container-abm-page']}>
        <div className={classes['table-templates-container']}>
          <DataTable 
           headers={dataHeader}
           rows={dataShow}
           countItems={countItems}
           rowsPerPage={dataTo}
           hasActions={false}
           appendOnScrollToBottom={false}
           onPageSizeChange={(size) => {setDataTo(size); setDataOffset(0); setPage(1);}}
           onPageChange={(page: number)=>{ setPage(page); setDataOffset(page-1) }}
           pageSelected={page}
           pageable={true}
           selectable={false}
          >
          </DataTable>
      </div>
    </div>
    </div>
  )
}

export default TransactionsReport;
